/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-04T17:36:00+05:00
Intent: One way to write a plan price everywhere: amount with thousands separators, then the currency (150,000 USD).
*/

/**
 * A price as the plans pages show it: "150,000 USD", "2,850 USD", "1,500 AED".
 *
 * Grouped digits, at most two decimals (a percentage discount can leave cents), and the currency
 * after the amount. Plan cards used to print the raw number (150000 USD) while the Web QR cards
 * printed "AED 1,500", so the same page wrote prices two ways.
 * A value that is not a number (e.g. "Contact us") is returned as it came.
 */
export function formatPlanPrice(amount: any, currency?: string | null): string {
  const value = typeof amount === 'string' && amount.trim() !== '' ? Number(amount) : amount;
  if (typeof value !== 'number' || !isFinite(value)) return String(amount ?? '').trim();
  const unit = String(currency ?? '').trim();
  const formatted = value.toLocaleString('en-US', { maximumFractionDigits: 2 });
  return unit ? `${formatted} ${unit}` : formatted;
}
